import type { PosLocalTerminal } from "@/platform/types";

/**
 * Qué es este equipo para el mostrador de un local (contrato §0 de
 * `OFFLINE-POS-RONDA-1.md`):
 *
 * - `caja`: es una caja dada de alta en este local. Sus ventas inmediatas
 *   pasan por la cola.
 * - `sin-alta`: no es una caja (o el alta no terminó). Vende online, como la
 *   web, con un aviso para darlo de alta. Así una actualización no frena a un
 *   local donde no están el dueño ni el encargado.
 * - `otro-local`: es la caja de otro local del negocio. Acá vende online.
 * - `dada-de-baja`: la caja de este local se dio de baja: no vende.
 */
export type SituacionDelEquipo =
  | { tipo: "caja"; terminal: PosLocalTerminal }
  | { tipo: "sin-alta" }
  | { tipo: "otro-local"; terminal: PosLocalTerminal }
  | { tipo: "dada-de-baja"; terminal: PosLocalTerminal };

export function situacionDelEquipo(
  terminal: PosLocalTerminal | null | undefined,
  warehouseId: string | undefined
): SituacionDelEquipo {
  if (!terminal?.terminalId || !terminal.prefix) return { tipo: "sin-alta" };
  if (terminal.warehouseId !== warehouseId) {
    return { tipo: "otro-local", terminal };
  }
  if (terminal.status === "deactivated") {
    return { tipo: "dada-de-baja", terminal };
  }
  return { tipo: "caja", terminal };
}

/**
 * Las ventas inmediatas de este equipo pasan por la cola (#338 AC-A): sólo en
 * el escritorio, y sólo si es una caja de este local. Lo leen la venta y el
 * botón de imprimir de antes de vender, que en una caja no está.
 */
export function vendePorLaCola(
  escritorio: boolean,
  terminal: PosLocalTerminal | null | undefined,
  warehouseId: string | undefined
): boolean {
  return (
    escritorio && situacionDelEquipo(terminal, warehouseId).tipo === "caja"
  );
}
